module.exports = __webpack_public_path__ + "img/cab_180.5fe166c6.jpg";